import React, { FC } from "react";
import {
  Autocomplete,
  Chip,
  InputLabel,
  TextField,
  Tooltip,
} from "@mui/material";
import "./styles.css";
import { ErrorMessage } from "../errorMessage";
import { KeyboardArrowDown } from "@mui/icons-material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export type listOptionContent = {
  value: string | number;
  label: string;
  id?: string;
};

export type ZSlistOptionContent = {
  value: string | number;
  label: string;
};

type ZSAutocompleteProps =
  | {
      id?: string;

      label?: string;
      placeholder?: string;
      multiSelect?: true;
      options: ZSlistOptionContent[];
      defaultValue?: any;
      value?: any;
      setValue: Function;
      errorMessage?: string;
      refetchFunction?: Function;
      setBlur?: Function;
      required?: boolean;
      prefix?: any;
      disableClearable?: boolean;
      nonRenderTags?: string[];
      direction?: "ltr" | "rtl";
      disabled?: boolean;
      infoText?: string | undefined;
      // onAddNew?: () => void;
      // addNewText?: string;
      insideTextFieldLabel?: string;
      autoCompleteBoxContainerWidth?: string;
      textFieldClassName?: string;
    }
  | {
      id?: string;
      label?: string;
      placeholder?: string;
      multiSelect?: false;
      options: ZSlistOptionContent[];
      defaultValue?: any;
      value?: any;
      setValue: Function;
      errorMessage?: string;
      refetchFunction?: Function;
      setBlur?: Function;
      required?: boolean;
      prefix?: any;
      disableClearable?: boolean;
      nonRenderTags?: string[];
      direction?: "ltr" | "rtl";
      disabled?: boolean;
      infoText?: string | undefined;
      // onAddNew?: () => void;
      // addNewText?: string;
      insideTextFieldLabel?: string;
      autoCompleteBoxContainerWidth?: string;
      textFieldClassName?: string;
    };

export const ZSAutocomplete: FC<ZSAutocompleteProps> = ({
  id,
  label,
  placeholder,
  disableClearable = false,
  multiSelect = false,
  options = [],
  setValue,
  value,
  errorMessage,
  defaultValue,
  refetchFunction = () => {},
  setBlur = () => {},
  required,
  prefix,
  nonRenderTags = [],
  direction = "ltr",
  disabled = false,
  infoText = undefined,
  // onAddNew,
  // addNewText = "Add new item",
  insideTextFieldLabel = "",
  autoCompleteBoxContainerWidth = "",
  textFieldClassName,
}) => {
  const SearchChangeFunction = debounce((searchValue: string) => {
    refetchFunction(searchValue.toLowerCase());
  }, 1000);

  function debounce(callback: any, delay = 1000) {
    let time: any;
    return (...args: any) => {
      clearTimeout(time);
      time = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  }

  const isRender = (value: string) => {
    return !nonRenderTags.includes(value);
  };

  // const enhancedOptions = [
  //   ...(options || []),
  //   { value: "add_new", label: addNewText },
  // ];

  return (
    <div
      className="autoCompleteBoxContainer"
      style={{ width: autoCompleteBoxContainerWidth }}
    >
      {label && (
        <InputLabel className={`${infoText && "autoCompleteInputLabel"}`}>
          {label}
          {required ? " * " : ""}
          {infoText && (
            <Tooltip arrow placement="top" title={infoText}>
              <InfoOutlinedIcon
                fontSize="small"
                className="infoOutlinedIconStyle"
              />
            </Tooltip>
          )}
        </InputLabel>
      )}
      <Autocomplete
        disableClearable={disableClearable}
        multiple={multiSelect}
        disableCloseOnSelect={multiSelect}
        // onChange={(event: React.SyntheticEvent, value: any) => {
        //   setBlur();
        //   if (value?.value === "add_new" && onAddNew) {
        //     onAddNew();
        //     return;
        //   }
        //   setValue(value);
        // }}
        onChange={(event: React.SyntheticEvent, value: any) => {
          setBlur();
          setValue(value);
        }}
        disabled={disabled}
        onInputChange={(
          event: React.SyntheticEvent,
          value: string,
          reason: string
        ) => {
          if (reason !== "reset") SearchChangeFunction(value);
        }}
        defaultValue={defaultValue}
        value={value}
        // onBlur={() => {
        //   setBlur();
        // }}
        // options={enhancedOptions}
        options={options ?? []}
        getOptionLabel={(option) => `${option?.label}`}
        isOptionEqualToValue={(option, val) => option?.value === val?.value}
        // renderOption={(props, option) => (
        //   <li
        //     style={{
        //       direction,
        //       fontWeight: option.value === "add_new" ? 600 : 400,
        //     }}
        //     {...props}
        //     onClick={() => {
        //       if (option.value === "add_new") {
        //         onAddNew?.();
        //       }
        //     }}
        //   >
        //     {option?.label}
        //   </li>
        // )}
        renderOption={(props, option) => {
          const { key, ...rest } = props;
          return (
            <li key={key} style={{ direction }} {...rest}>
              {option?.label}
            </li>
          );
        }}
        popupIcon={<KeyboardArrowDown />}
        renderTags={(value, getTagProps) =>
          value.map(
            (option: any, index: number) =>
              isRender(option?.value) && (
                <Chip
                  label={option?.label}
                  {...getTagProps({ index })}
                  className="chipAutocomplete"
                  size="small"
                />
              )
          )
        }
        renderInput={(params) => (
          <TextField
            {...params}
            className={textFieldClassName}
            variant="standard"
            size="small"
            error={errorMessage ? true : false}
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              startAdornment: (
                <>
                  <span>{insideTextFieldLabel} </span>
                  {multiSelect
                    ? null
                    : prefix && (
                        <Chip
                          tabIndex={-1}
                          label={prefix}
                          className="adornment-chip"
                          size="small"
                          style={{ marginRight: "4px" }}
                        />
                      )}
                </>
              ),
            }}
          />
        )}
      />
      {errorMessage !== undefined && (
        <ErrorMessage message={errorMessage ?? null} />
      )}
    </div>
  );
};
